import { useId } from 'react';
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { usePortal } from './hooks/usePortal';

interface Props {
  portalId?: string;
  children: ReactNode;
}

export const Portal = ({ portalId, children }: Props) => {
  const defaultId = useId();
  const portal = usePortal({
    id: portalId ?? defaultId,
  });

  if (portal) {
    return createPortal(children, portal);
  }

  return null;
};
